/** 교육·학원 포트폴리오 스크린샷 — public/portfolio/education/ */

function educationSrc(filename) {
  return `/portfolio/education/${encodeURIComponent(filename)}`;
}

function educationItem(id, title, filename, url) {
  return { id, title, url, src: educationSrc(filename) };
}

export const EDUCATION_PORTFOLIO_IMAGES = [
  educationItem("arte-art", "아르테 아트 아카데미", "5.webp", "arte-art-academy.dsite"),
  educationItem("studyflow", "스터디플로우", "1.webp", "studyflow.dsite"),
  educationItem("codecampus", "코드캠퍼스", "3.webp", "codecampus.dsite"),
  educationItem("growlearn", "그로우런", "2.webp", "growlearn.dsite"),
  educationItem("design-academy", "디자인 아카데미", "4.webp", "design-academy.dsite"),
  educationItem("axis-education", "엑시스 에듀케이션", "6.webp", "axis-education.dsite"),
];

export const DEFAULT_EDUCATION_IMAGE = EDUCATION_PORTFOLIO_IMAGES[0];
